var React = require('react');

function HeartIconFilled (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".b{fill:#5a008a;}")),React.createElement("path",{"className":"b","d":"M20.39,1.95l-.34-.34c-1.04-1.04-2.42-1.61-3.89-1.61s-2.85,.57-3.89,1.61l-.68,.68-.57,.59s-.26-.23-1.3-1.27C8.68,.57,7.3,0,5.83,0S2.99,.57,1.95,1.61l-.34,.34C-.54,4.09-.54,7.58,1.61,9.73l9.39,9.39,9.39-9.39c2.14-2.14,2.14-5.63,0-7.77Z","key":1})]);
}

HeartIconFilled.defaultProps = {"id":"a","width":"23","height":"20","viewBox":"0 0 21.99 19.12"};

module.exports = HeartIconFilled;

HeartIconFilled.default = HeartIconFilled;
